<app-load-master-data>
    <app-activity-selector
        [activities]="activities()"
        (activitySelected)="onActivityChange($event)"
        data-test="activity-selector-page"
    />

    @if (selectedActivity()) {
        @switch (componentState()) {
            @case (ComponentState.SelectRow) {
                <app-map-row-selector
                    data-test="map-row-selector"
                    class="animate"
                    @slideInOut
                    (closeRequested)="onCloseRowOverlayRequested()"
                    (rowsSelected)="onRowsSelected()"
                    [title]="selectedActivityTitle()"
                    [selectedActivity]="selectedActivity()"
                />
            }
            @case (ComponentState.SelectContainer) {
                <app-container-selector
                    class="animate"
                    @slideInOutContainers
                    [activity]="selectedActivity()"
                    [multiple]="false"
                    [title]="selectedActivityTitle()"
                    (containersSelected)="onContainersSelected($event)"
                    (closeRequested)="goBack()"
                    data-test="container-selector-page"
                />
            }
            @case (ComponentState.SelectContainers) {
                <app-container-selector
                    class="animate"
                    @slideInOutContainers
                    [activity]="selectedActivity()"
                    [multiple]="true"
                    [title]="selectedActivityTitle()"
                    (containersSelected)="onContainersSelected($event)"
                    (closeRequested)="goBack()"
                    data-test="multiple-container-selector-page"
                />
            }
            @case (ComponentState.SelectBatch) {
                <app-batch-selector
                    class="animate"
                    @slideInOut
                    (closeRequested)="onCloseRowOverlayRequested()"
                    (batchSelected)="onBatchSelected($event)"
                    [title]="selectedActivityTitle()"
                    data-test="batch-selector-page"
                />
            }
            @case (ComponentState.SelectLocation) {
                <app-location-selector
                    class="animate"
                    @slideInOut
                    [activity]="selectedActivity()"
                    (closeRequested)="onCloseRowOverlayRequested()"
                    (locationSelected)="onLocationSelected($event)"
                    [title]="selectedActivityTitle()"
                    data-test="location-selector-page"
                />
            }
            @case (ComponentState.SelectEmployee) {
                <app-employee-selector
                    class="animate"
                    @slideInOut
                    [title]="selectedActivityTitle()"
                    (employeeSelected)="onEmployeeSelected($event)"
                    (closeRequested)="goBack()"
                    data-test="employee-selector-page"
                />
            }
            @case (ComponentState.SelectAmountResult) {
                <app-manual-input-amount-result
                    class="animate"
                    @slideInOut
                    [title]="selectedActivityTitle()"
                    [activity]="selectedActivity()"
                    (amountResultSelected)="onAmountResultSelected($event)"
                    (closeRequested)="goBack()"
                    data-test="amount-result-selector-page"
                />
            }
            @case (ComponentState.SelectAmountAndProductBox) {
                <app-manual-input-product-box-amount
                    class="animate"
                    @slideInOut
                    [title]="selectedActivityTitle()"
                    [activity]="selectedActivity()"
                    (productBoxAmountsSelected)="onProductBoxAmountsSelected($event)"
                    (closeRequested)="goBack()"
                    data-test="product-box-amount-selector-page"
                />
            }
            @case (ComponentState.SelectProductBox) {
                <app-manual-input-product-box
                    class="animate"
                    @slideInOut
                    [title]="selectedActivityTitle()"
                    [activity]="selectedActivity()"
                    (productBoxSelected)="onProductBoxSelected($event)"
                    (closeRequested)="goBack()"
                    data-test="product-box-selector-page"
                />
            }
        }
    }
</app-load-master-data>
